import React, { useContext, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';

import { useNavigate } from 'react-router-dom';

import { AuthContext } from '../../auth/AuthContext';
import { useContextInfo } from '../../context/ContextInfo';
import { uploadFile } from '../../api/fetch';
import moment from 'moment';

const AddRespuesta = ({ id }) => {
    const { auth } = useContext(AuthContext);
    const { setResp } = useContextInfo();
    const [file, setFile] = useState();
    const [validated, setValidated] = useState(false);
    const [send, setSend] = useState(false);

    const [respuesta, setRespuesta] = useState('');
    const navigate = useNavigate();

    const saveFile = (e) => {
        if (e.target.files.length === 0) return;
        setFile(e.target.files[0]);
    };

    const onSubmit = async (btn) => {
        setSend(true);
        if (send) return;
        let bodyContent = new FormData();
        bodyContent.append('contenido', respuesta);
        bodyContent.append('idagent', auth.uid);
        bodyContent.append('fecha', moment().format('YYYY-MM-DD hh:mm:ss'));
        bodyContent.append('archivo', file);
        bodyContent.append('state', 1);

        const res = await uploadFile(bodyContent, `tickets/${btn}/${id}`, 'PUT');
        setResp(res);
        setSend(false);
        if (res.ok) {
            navigate(`/admin/tickets/open`);
        }
    };
    const todoOk = () => {
        return respuesta.length === 0 ? true : false;
    };
    return (
        <Card className="mt-2">
            <Card.Header className="bg-light">
                <h4 className="modal-title">Respuesta</h4>
            </Card.Header>
            <Card.Body>
                <Form noValidate validated={validated} onSubmit={onSubmit}>
                    <Form.Group className="mb-3" controlId="validationCustom121">
                        <Form.Label> Detalles del ticket </Form.Label>
                        <Form.Control
                            type="text"
                            as="textarea"
                            value={respuesta}
                            name="sms"
                            onChange={(e) => setRespuesta(e.target.value)}
                        />
                    </Form.Group>{' '}
                    <Form.Group>
                        <Form.Label htmlFor="file">Adjuntar archivo</Form.Label>
                        <Form.Control type="file" onChange={saveFile} id="small_size" accept="image/*, .pdf, .doc" />
                    </Form.Group>
                    {send ? (
                        <Button color="primary" disabled>
                            <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                            Guardando...
                        </Button>
                    ) : (
                        <>
                            <Button
                                type="button"
                                disabled={todoOk()}
                                onClick={() => onSubmit('close')}
                                className="mt-2 ml-2">
                                Responder y Cerrar Ticket
                            </Button>
                            <Button
                                type="button"
                                onClick={() => onSubmit('reply')}
                                disabled={todoOk()}
                                className="mt-2 mx-2">
                                Responder
                            </Button>{' '}
                        </>
                    )}
                </Form>
            </Card.Body>
        </Card>
    );
};

export default AddRespuesta;
